import React, { useState } from "react";
import {
    Box,
    Typography,
    Paper,
    Stack,
    Button,
    CircularProgress,
    Alert,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import axios from "axios";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import apiUrl from "../../Config";

const STATUS_OPTIONS = [
    { value: "pending", label: "Pending" },
    { value: "completed", label: "Completed" },
    { value: "under_review", label: "Under Review" },
    { value: "rejected", label: "Rejected" }
];

const UpdateTechnicianPayouts = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [proof, setProof] = useState(null);
    const [proofPreview, setProofPreview] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [status, setStatus] = useState(location.state?.status);

    const technicianName = location.state?.technicianName || "";

    const handleProofChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProof(file);
            setProofPreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        if (status === "completed" && !proof) {
            setError("Proof image is required.");
            return;
        }
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("status", status);
            if (status === "completed" && proof) {
                formData.append("proof", proof);
            }

            await axios.post(
                `${apiUrl}/technicianpayout/updatepayout/${id}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            setSuccess("Payout updated successfully!");
            setTimeout(() => navigate("/technician-payouts"), 1500);
        } catch (err) {
            setError("Failed to update payout.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 500, mx: "auto" }}>
            <Typography variant="h4" gutterBottom>
                Update Technician Payout
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Paper elevation={2} sx={{ p: 3 }}>
                <form onSubmit={handleSubmit}>
                    <Stack spacing={3}>
                        <Box>
                            <Typography variant="subtitle1" gutterBottom>
                                Person Name : <strong>{technicianName || <span style={{ color: "#888" }}>No Name Provided</span>}</strong>
                            </Typography>
                            <FormControl size="small" fullWidth sx={{ mt: 1 }}>
                                <InputLabel>Status</InputLabel>
                                <Select
                                    label="Status"
                                    value={status}
                                    onChange={e => setStatus(e.target.value)}
                                >
                                    {STATUS_OPTIONS.map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        {status === "completed" && (
                            <Box>
                                <Typography variant="subtitle1" gutterBottom>
                                    Proof Image <span style={{ color: "red" }}>*</span>
                                </Typography>
                                {proofPreview && (
                                    <Box sx={{ mb: 2, textAlign: "center" }}>
                                        <img
                                            src={proofPreview}
                                            alt="Proof Preview"
                                            style={{ maxWidth: "100%", maxHeight: 200, borderRadius: 8 }}
                                        />
                                    </Box>
                                )}
                                <Button
                                    variant="outlined"
                                    component="label"
                                    fullWidth
                                    sx={{ mb: 1 }}
                                >
                                    Upload Proof
                                    <input
                                        type="file"
                                        accept="image/*"
                                        hidden
                                        onChange={handleProofChange}
                                    />
                                </Button>
                            </Box>
                        )}

                        {error && <Alert severity="error">{error}</Alert>}
                        {success && <Alert severity="success">{success}</Alert>}
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={loading}
                            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                            fullWidth
                        >
                            {loading ? "Updating..." : "Update Payout"}
                        </Button>
                    </Stack>
                </form>
            </Paper>
        </Box>
    )
}

export default UpdateTechnicianPayouts;

